<div
  [class.fixed]="!centered"
  [class.right-10]="!centered"
  [class.bottom-10]="!centered"
  [class.w-full]="centered"
  [class.flex]="centered"
  [class.justify-center]="centered"
>
  <div
    class="flex flex-col items-center justify-center text-center"
  >
    <div class="loading-medallion">
      <app-logo class="loading-medallion-logo"></app-logo>
    </div>
    @if (message) {
      <span class="sr-only" role="status" aria-live="polite">
        {{ message }}
      </span>
    }
  </div>
</div>
